import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type AcceptProvingChangeMutationVariables = {
  changeId: Types.Scalars['String']
};


export type AcceptProvingChangeMutation = (
  { __typename?: 'Mutation' }
  & { resolveProvingChange: (
    { __typename?: 'ProvingChange' }
    & Pick<Types.ProvingChange, '_id'>
  ) }
);

export type RejectProvingChangeMutationVariables = {
  changeId: Types.Scalars['String']
};


export type RejectProvingChangeMutation = (
  { __typename?: 'Mutation' }
  & { resolveProvingChange: (
    { __typename?: 'ProvingChange' }
    & Pick<Types.ProvingChange, '_id'>
  ) }
);

export type AcceptProvingChangesMutationVariables = {
  changeIds: Array<Types.Scalars['String']>
};


export type AcceptProvingChangesMutation = (
  { __typename?: 'Mutation' }
  & { resolveProvingChanges: Array<(
    { __typename?: 'ProvingChange' }
    & Pick<Types.ProvingChange, '_id'>
  )> }
);

export type RejectProvingChangesMutationVariables = {
  changeIds: Array<Types.Scalars['String']>
};


export type RejectProvingChangesMutation = (
  { __typename?: 'Mutation' }
  & { resolveProvingChanges: Array<(
    { __typename?: 'ProvingChange' }
    & Pick<Types.ProvingChange, '_id'>
  )> }
);

export const AcceptProvingChangeDocument = gql`
    mutation AcceptProvingChange($changeId: String!) {
  resolveProvingChange(changeId: $changeId, action: ACCEPT) {
    _id
  }
}
    `;
export type AcceptProvingChangeMutationFn = ApolloReactCommon.MutationFunction<AcceptProvingChangeMutation, AcceptProvingChangeMutationVariables>;

    export function useAcceptProvingChangeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptProvingChangeMutation, AcceptProvingChangeMutationVariables>) {
      return ApolloReactHooks.useMutation<AcceptProvingChangeMutation, AcceptProvingChangeMutationVariables>(AcceptProvingChangeDocument, baseOptions);
    };
export type AcceptProvingChangeMutationHookResult = ReturnType<typeof useAcceptProvingChangeMutation>;
export type AcceptProvingChangeMutationResult = ApolloReactCommon.MutationResult<AcceptProvingChangeMutation>;
export type AcceptProvingChangeMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptProvingChangeMutation, AcceptProvingChangeMutationVariables>;
export const RejectProvingChangeDocument = gql`
    mutation RejectProvingChange($changeId: String!) {
  resolveProvingChange(changeId: $changeId, action: REJECT) {
    _id
  }
}
    `;
export type RejectProvingChangeMutationFn = ApolloReactCommon.MutationFunction<RejectProvingChangeMutation, RejectProvingChangeMutationVariables>;

    export function useRejectProvingChangeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectProvingChangeMutation, RejectProvingChangeMutationVariables>) {
      return ApolloReactHooks.useMutation<RejectProvingChangeMutation, RejectProvingChangeMutationVariables>(RejectProvingChangeDocument, baseOptions);
    };
export type RejectProvingChangeMutationHookResult = ReturnType<typeof useRejectProvingChangeMutation>;
export type RejectProvingChangeMutationResult = ApolloReactCommon.MutationResult<RejectProvingChangeMutation>;
export type RejectProvingChangeMutationOptions = ApolloReactCommon.BaseMutationOptions<RejectProvingChangeMutation, RejectProvingChangeMutationVariables>;
export const AcceptProvingChangesDocument = gql`
    mutation AcceptProvingChanges($changeIds: [String!]!) {
  resolveProvingChanges(changeIds: $changeIds, action: ACCEPT) {
    _id
  }
}
    `;
export type AcceptProvingChangesMutationFn = ApolloReactCommon.MutationFunction<AcceptProvingChangesMutation, AcceptProvingChangesMutationVariables>;

    export function useAcceptProvingChangesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptProvingChangesMutation, AcceptProvingChangesMutationVariables>) {
      return ApolloReactHooks.useMutation<AcceptProvingChangesMutation, AcceptProvingChangesMutationVariables>(AcceptProvingChangesDocument, baseOptions);
    };
export type AcceptProvingChangesMutationHookResult = ReturnType<typeof useAcceptProvingChangesMutation>;
export type AcceptProvingChangesMutationResult = ApolloReactCommon.MutationResult<AcceptProvingChangesMutation>;
export type AcceptProvingChangesMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptProvingChangesMutation, AcceptProvingChangesMutationVariables>;
export const RejectProvingChangesDocument = gql`
    mutation RejectProvingChanges($changeIds: [String!]!) {
  resolveProvingChanges(changeIds: $changeIds, action: REJECT) {
    _id
  }
}
    `;
export type RejectProvingChangesMutationFn = ApolloReactCommon.MutationFunction<RejectProvingChangesMutation, RejectProvingChangesMutationVariables>;

    export function useRejectProvingChangesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectProvingChangesMutation, RejectProvingChangesMutationVariables>) {
      return ApolloReactHooks.useMutation<RejectProvingChangesMutation, RejectProvingChangesMutationVariables>(RejectProvingChangesDocument, baseOptions);
    };
export type RejectProvingChangesMutationHookResult = ReturnType<typeof useRejectProvingChangesMutation>;
export type RejectProvingChangesMutationResult = ApolloReactCommon.MutationResult<RejectProvingChangesMutation>;
export type RejectProvingChangesMutationOptions = ApolloReactCommon.BaseMutationOptions<RejectProvingChangesMutation, RejectProvingChangesMutationVariables>;